<template>
    <sys-register-base 
        :loading="loading" 
        @onSave="save" 
        :model.sync="model" 
        :title="title" 
        icon="mdi-account-group-outline" 
        v-bind:show.sync="dialog"
        maxWidth="60%"
    >
        <template v-slot:form>
            <v-tabs v-model="tab">
                <!-- tab-value (não `value`): em Vuetify 2 o VTab lê a chave do
                     grupo dessa prop. Sem ela o pareamento volta a ser por
                     índice e desalinha quando uma aba tem v-if. -->
                <v-tab key="main" tab-value="main">Dados</v-tab>
                <v-tab key="offer" tab-value="offer">Oferta</v-tab>
                <v-tab key="trail" tab-value="trail" v-if="model && model.id">Trilha</v-tab>
                <v-tab key="others" tab-value="others">Demais Dados</v-tab>
                <v-tab key="students" tab-value="students">Alunos</v-tab>
                <v-tab key="availability" tab-value="availability" v-if="model && model.id">Disponibilidade</v-tab>

            </v-tabs>
            <v-tabs-items v-model="tab">
                <v-tab-item key="main" value="main">
                    <v-card flat>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <SelectCourse
                                        v-model="model.course_id"
                                        :item.sync="model.course"
                                        :disabled="disableCourse"  
                                        :error-messages="errors.course_id"
                                    />
                                </v-col>
                                <v-col cols="12" md="6">
                                    <FormsTextField 
                                        v-model="model.name"
                                        :error-messages="errors.name"
                                        label="Nome*"
                                    />
                                </v-col>
                                <v-col cols="12" md="6">
                                    <SelectShift
                                        v-model="model.shift_id"
                                        :item.sync="model.shift"
                                        :error-messages="errors.shift_id"
                                        load-data
                                    />
                                </v-col>
                                <v-col cols="12" md="6">
                                    <SelectStatusGroup 
                                        v-model="model.status_group_id"
                                        :item.sync="model.status"
                                        :error-messages="errors.status_group_id"
                                        load-data
                                    />
                                </v-col>

                                <v-col cols="12" md="6">
                                    <SelectCampus
                                        v-model="model.campus_id"
                                        :item.sync="model.campus"
                                        :error-messages="errors.campus_id"
                                    />
                                </v-col>
                                <v-col cols="12" md="6">
                                    <SelectCategoryGroup
                                        v-model="model.category_group_id"
                                        :item.sync="model.category"
                                        :error-messages="errors.category_group_id"
                                        clearable
                                        show-add
                                        load-data
                                    />
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" md="3">
                                    <FormsTextField 
                                        v-model="model.group" 
                                        :error-messages="errors.group" 
                                        label="Turma" 
                                    />
                                </v-col>

                                <v-col cols="12" md="3">
                                    <FormsTextField 
                                        v-model="model.time_course"
                                        :error-messages="errors.time_course"
                                        label="Período"
                                    />
                                </v-col>
                                <v-col cols="12" md="3">
                                    <FormsTextField 
                                        v-model="model.code" 
                                        :error-messages="errors.code" 
                                        label="Código"
                                        code
                                        />
                                </v-col>
                                <v-col cols="12" md="3">
                                    <FormsTextField 
                                        v-model="model.code_control" 
                                        :error-messages="errors.code_control"
                                        label="Código Controle"
                                        code
                                        />
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                 </v-tab-item>

                 <!-- Oferta -->
                  <v-tab-item key="offer" value="offer">
                    <v-container>
                    <v-row v-if="showOffer">
                        <v-col cols="12" sm="12">
                            <div>
                                <v-row>
                                    <v-col cols="12" sm="12">
                                        <v-card outlined class="pa-3">
                                            <div class="text-overline mb-2 grey--text text--darken-1">Matriz Curricular da Turma</div>
                                            <sys-select-curriculum
                                                :model.sync="model.curriculum_id"
                                                :error="errors.length > 0"
                                                :errors="errors.curriculum_id"
                                                label="Matriz Curricular"
                                                :courseId="model.course_id"
                                                clearable
                                                :modelObject.sync="selectedCurriculum"
                                                @clearSelected="selectedCurriculum = {}"
                                                autoComplete
                                                dense
                                                hint="Define o universo de disciplinas e pré-requisitos. Pode ficar em branco para oferta livre."
                                                persistent-hint
                                            />
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="12">
                                        <OfferIntentsPlanning
                                            ref="offerIntentsPlanning"
                                            :group-id="model && model.id"
                                            :group-work-time-id="(model && model.work_time_id) || workTime.id"
                                            :modules="(selectedCurriculum && selectedCurriculum.sequencies) || []"
                                            :current-sequency-id="model && model.curriculum_sequency_item_id"
                                            :offer-errors="offerIntentErrors"
                                            @update:currentSequencyId="onPlanningSequencyChange"
                                            @update:draftIntents="onDraftIntentsChange"
                                            @bulk-generate="bulkGenerateFromIntents"
                                        />
                                        <emc-alert-snackbar
                                            :show="!! bulkMessage.length"
                                            :message="bulkMessage"
                                            :color="bulkMessageColor"
                                        />
                                    </v-col>
                                </v-row>
                            </div>
                        </v-col>
                    </v-row>
                    </v-container>

                 </v-tab-item>

                 <!-- Trilha -->
                 <v-tab-item key="trail" value="trail" v-if="model && model.id">
                    <v-container>
                        <GroupTrail
                            :group-id="model.id"
                            :course-id="model.course_id"
                        />
                    </v-container>
                 </v-tab-item>

                 <!-- Demais Dados -->
                 <v-tab-item key="others" value="others">
                    <v-container>
                        <v-row>
                            <v-col cols="12" md="6">                                
                                <SelectBaseGroup
                                    v-model="model.baseGroups"
                                    :item="model.baseGroups"
                                    :error-messages="errors.base_group_id"
                                    label="Ingressantes"
                                    multiple
                                    return-object
                                    clearable
                                    :filters="baseGroupFilters"
                                />
                            </v-col>
                            <v-col cols="12" md="6">
                                <FormsTextField
                                    v-model="model.code_curriculum"
                                    :error-messages="errors.code_curriculum"
                                    label="Matriz Aplicada" 
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="6">
                                <SelectResource 
                                    v-model="model.resources"
                                    :item.sync="model.resources"
                                    :errors="errors.resources"
                                    label="Recursos Necessários"
                                    multiple
                                    return-object
                                />

                            </v-col>
                            <v-col cols="12" md="6">
                                <SelectHourGroup 
                                    v-model="model.hour_group_id"
                                    :errors="errors.hour_group_id"
                                    :item.sync="model.hourGroup"
                                    clearable
                                    load-data
                                />
                            </v-col>
                            <v-col cols="12" md="6">
                                <SelectShift 
                                    v-model="model.time_shift_id"
                                    :item.sync="model.timeShift"
                                    :errors="errors.time_shift_id"
                                    label="Turno do Horário"
                                    clearable
                                    load-data
                                />
                            </v-col>
                            <v-col cols="12" md="6">
                                <FormsTextField 
                                    v-model="model.weeks"
                                    text-helper="Número de semanas letivas. Utilizado para converter a carga horária total para semanal. Se não informado, utiliza o valor padrão cadastrado no Período Letivo"
                                    :error-messages="errors.weeks" 
                                    label="Número de Semanas" 
                                />
                            </v-col>
                            <v-col cols="12" md="6">
                                <SelectBranch
                                    v-model="model.branch_id"
                                    :item.sync="model.branch"
                                    :errors="errors.branch_id"
                                    :filters="branchFilters"
                                    clearable
                                />
                            </v-col>
                            <v-col cols="12" md="6">
                                <SelectIdentifier
                                    v-model="model.group_identifier_id"
                                    :errors="errors.group_identifier_id"
                                    :item.sync="model.identifier"
                                    clearable
                                    show-add
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="6">
                                <SelectAmbienceCategory
                                    v-model="model.category_ambience_id"
                                    :errors="errors.category_ambience_id"
                                    :item.sync="model.categoryAmbience"
                                    show-add
                                    clearable
                                />
                            </v-col>
                            <v-col cols="12" md="6">
                                <SelectAmbience
                                    v-model="model.ambience_id"
                                    :errors="errors.ambience_id"
                                    :item.sync="model.ambience"
                                    clearable
                                />
                            </v-col>
                            <v-col cols="12" md="6">
                                <SelectWorkTimeDate
                                    v-model="model.work_time_date_id"
                                    :item.sync="model.workTimeDate"
                                    :errors="errors.work_time_date_id"
                                    load-data
                                    clearable
                                />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <SelectCampus 
                                    v-model="model.campus_id_alternative"
                                    :errors="errors.campus_id_alternative"
                                    :item.sync="model.campusAlternative"
                                    label="Campus Alternativo"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="4">
                                <sys-select-integration-shift
                                    :model.sync="model.integration_shift_id"
                                    :error="errors.length > 0"  
                                    :errors="errors.integration_shift_id"
                                    label="Turno - Integração"
                                    clearable
                                    :shiftId="model.shift_id"
                                />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <s-switch text-helper="Bloquear atribuição de professor" inset v-model="model.lock_attribution" label="Bloquear Atribuição"/>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <s-switch inset v-model="model.freshmen_group" label="Calouro"/>
                            </v-col>
                        </v-row>
                    </v-container>
                 </v-tab-item>

                <!-- Alunos -->
                <v-tab-item key="students" value="students">
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="4">
                                <s-text-field 
                                    v-model="model.students" 
                                    dense
                                    :error-messages="errors.students" 
                                    label="Alunos"
                                    clearable
                                />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <s-text-field 
                                    v-model="model.students_forecast" 
                                    dense
                                    :error-messages="errors.students_forecast" 
                                    label="Alunos Previsão"
                                    clearable
                                />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <s-text-field 
                                    v-model="model.students_max" 
                                    dense
                                    :error-messages="errors.students_max" 
                                    label="Vagas"
                                    clearable
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="4">
                                <s-text-field 
                                    v-model="model.students_freshmen" 
                                    dense
                                    :error-messages="errors.students_freshmen" 
                                    label="Calouros"
                                    clearable
                                />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <s-text-field 
                                    v-model="model.students_free" 
                                    dense
                                    :error-messages="errors.students_free"
                                    label="Bolsistas"
                                    clearable
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>

                <!-- Disponibilidade -->
                 <v-tab-item key="availability" value="availability" v-if="model && model.id">
                    <sys-availability-register :model="model" />
                 </v-tab-item>

                 
            </v-tabs-items>

            <v-alert v-if="errors.generate" type="error">
                <ul>
                    <li :key="i" v-for="(error, i) in errors.generate">
                    {{ error }}
                    </li>
                </ul>
            </v-alert>
            
            <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>

            <sys-find-discipline 
                showAdd 
                showSelect
                :singleSelect="false" 
                @onSelect="selectDiscipline($event)" 
                :show.sync="dialogAddDiscipline"
            />

            <emc-alert-modal :disabled="loadingOffer"  text="Confirma a geração da oferta a partir do planejamento?" v-bind:show.sync="showGenerateOffer">
                <template v-slot:actions>
                    <v-btn
                        :disabled="loadingOffer"
                        :loading="loadingOffer"
                        color="orange lighten-2"
                        @click.prevent.stop="pendingGenerationGroup ? generateOfferFromIntents() : generateOffer()"
                    >
                        Gerar Oferta<v-icon right dark>mdi-flash</v-icon>
                    </v-btn>
                </template>
            </emc-alert-modal>

            <emc-alert-modal text="Deseja excluir a disciplina?" v-bind:show.sync="showDeleteDiscipline">
                <template v-slot:actions>
                    <v-btn color="error" @click.prevent.stop="deleteItem()" >Excluir <v-icon right dark>mdi-delete</v-icon></v-btn>
                </template>
            </emc-alert-modal>

        </template>
    </sys-register-base>
</template>

<script>
import { mapActions, mapState } from 'vuex'

//Composition API
import SelectCourse from '../../../domains/course/course/components/SelectCourse.vue';
import SelectShift from '../../../domains/shift/components/SelectShift.vue';
import SelectStatusGroup from '../../../domains/group/status/components/SelectStatusGroup.vue';
import SelectCategoryGroup from '../../../domains/group/category/components/SelectCategoryGroup.vue';
import SelectCampus from '../../../domains/company/campus/components/SelectCampus.vue';
import SelectBaseGroup from '../../../domains/group/base/components/SelectBaseGroup.vue';
import SelectResource from '../../../domains/ambience/resource/components/SelectResource.vue';
import SelectAmbience from '../../../domains/ambience/ambience/components/SelectAmbience.vue';
import SelectAmbienceCategory from '../../../domains/ambience/category/components/SelectCategory.vue';
import SelectBranch from '../../../domains/company/branch/components/SelectBranch.vue';
import SelectIdentifier from '../../../domains/group/identifier/components/SelectIdentifier.vue';
import GroupTrail from './GroupTrail.vue';
import OfferIntentsPlanning from './OfferIntentsPlanning.vue';
import SelectHourGroup from '../../../domains/hour/group/components/SelectHourGroup.vue';
import SelectWorkTimeDate from '../../../domains/worktime/date/components/SelectWorkTimeDate.vue';

export default {
    name: "SysRegisterGroup",
    data: (vm) => ({
        dialog: false,
        workTime: null,
        tab: 'main',
        curriculumSequencyItemId: null,
        disciplinesSelected: [],
        offerTypeMode: 1,
        showOffer: true,
        draftOfferIntents: [],
        showGenerateOffer: false,
        pendingGenerationGroup: null,
        showDeleteDiscipline: false,
        selectedItem: null,
        error: false,
        errors: {},
        message: '',
        loading: false,
        loadingOffer: false,
        disableCourse: false,
        selectedCurriculum: {},
        bulkMessage: '',
        bulkMessageColor: 'info',
        dialogAddDiscipline: false,
        sequencies: [],
        disciplines: [],
        itemDelete: {},
        headers: [
            { text: 'Disciplina', value: 'name_complete'},
            { text: 'Carga Horária', value: 'work_load'},
            { text: 'Ações', value: 'actions', sortable: false}
        ]
    }),
    components: {
        SelectCourse,
        SelectShift,
        SelectStatusGroup,
        SelectCampus,
        SelectCategoryGroup,
        SelectBaseGroup,
        SelectResource,
        SelectHourGroup,
        SelectBranch,
        SelectIdentifier,
        GroupTrail,
        OfferIntentsPlanning,
        SelectAmbienceCategory,
        SelectWorkTimeDate,
        SelectAmbience
    },
    created(){
        this.workTime = this.acesso.periodo;
    },
    computed: {
        ...mapState('auth', ['acesso']),

        // Erros do planejamento de oferta devolvidos pelo POST /api/groups.
        // As chaves `discipline_<id>` não casam com nenhum campo do formulário,
        // então precisam de um destino próprio dentro da aba Oferta.
        offerIntentErrors() {
            const errors = this.errors || {};

            return Object.keys(errors)
                .filter(k => k.indexOf('discipline_') === 0 || k === 'work_time_id' || k === 'discipline_ids')
                .map(k => Array.isArray(errors[k]) ? errors[k][0] : errors[k])
                .filter(Boolean);
        },

        // Filtros pra SelectBaseGroup — computed pra ter identidade estável
        // (evita refetch a cada re-render do Group.vue).
        baseGroupFilters() {
            return {
                shift_id:  this.model && this.model.shift_id,
                campus_id: this.model && this.model.campus_id,
                course_id: this.model && this.model.course_id,
            }
        },

        // Filtros pra SelectBranch — idem.
        branchFilters() {
            return {
                campus_id: this.model && this.model.campus_id,
            }
        },

        showDisciplines: function(){

            if(this.offerTypeMode == 2){
                
                if(this.sequencies && this.model && this.curriculumSequencyItemId){
                
                    var sequency = this.sequencies.find(s => (s.id && s.id == this.model.curriculum_sequency_item_id));
                
                    if(sequency && sequency.sequencyDisciplines && sequency.sequencyDisciplines.length > 0){
                        return sequency.sequencyDisciplines;
                    }
                }
            }else if(this.offerTypeMode == 3){
                return this.disciplinesSelected;
            }
            
            return [];

        }
    },

    watch: {
        
        curriculumSequencyItemId(val){
            this.model.curriculum_sequency_item_id = val;
        },

        disciplinesSelected(val){
            
            this.model.disciplines = [];

            val.forEach(dic => {
                this.model.disciplines.push(dic.discipline);
            });
            
        },
        
        selectedCurriculum(val){

            this.sequencies = [];
            this.disciplines = [];

            if(val && val.sequencies){
                
                val.sequencies.forEach(seq => {
                    
                    if(seq.curriculum_sequency_id == 99){
                        seq.name = 'Atividades';
                    }else{
                        
                        if(seq.initials){
                            seq.name = seq.curriculum_sequency_id + ' - ' + seq.initials;
                        }else{
                            seq.name = seq.curriculum_sequency_id + 'º Período';
                        }
                    }

                    seq.sequencyDisciplines.forEach(dis => {
                        this.disciplines.push(dis);
                    });

                });

                this.sequencies = val.sequencies;


            }else{
                this.model.curriculum_sequency_item_id = null;
                this.model.curriculum_id = null;
                this.model.disciplines = [];
            }

        },
        
        dialog(dialog_new, dialog_old) {
            
            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }

        },

        show(show_new, show_old) {
            
            this.dialog = show_new;
           
            if(show_new){
                
                this.error = false;
                this.errors = {};
                this.tab = 'main';
                this.model.updateAvailability = false;
                this.disciplinesSelected = [];
                this.draftOfferIntents = [];

                if(!this.model || !this.model.id){
                    
                    //this.model.status_group_id = 1;
                    this.model.offer_type_id = 1;
                    this.offerTypeMode = 1;
                    this.model.disciplines = [];
                    this.curriculumSequencyItemId = null;
                    this.model.baseGroups = [];
                    this.model.availabilities = [];
                    this.model.category = null;
                    
                    if(this.model.course){
                        this.model.course_id = this.model.course.id;
                        this.disableCourse = true;
                    }
                }else{
                    this.offerTypeMode = this.model.offer_type_id;
                    this.curriculumSequencyItemId = this.model.curriculum_sequency_item_id;

                    this.model.disciplines.forEach(dic => {
                        this.disciplinesSelected.push({
                            discipline_id:  dic.id,
                            discipline:     { id: dic.id, name: dic.name, name_complete: dic.name_complete, work_load: dic.work_load },
                            category:       null,
                        });
                    });
                }
               
            }
                
        },
        
    },
    props: {
        model: {
            default: null
        },
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        icon: {
            type: String,
            default: "mdi-alert"
        },
        title: {
            type: String,
            default: "Turmas"
        },
        text: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        ...mapActions('group', ['ActionCreateGroup', 'ActionUpdateGroup', 'ActionGenerateGrids']),
                
        loadCourse(items){

            if(!this.model.id && this.model.course){
                this.model.course_id = this.model.course.id;
                this.disableCourse = true;
            }
        },

        changeOfferType(val){
            this.offerTypeMode = val;
        },

        onDraftIntentsChange(list){
            // Planejamento montado antes de a turma existir — enviado no POST.
            this.draftOfferIntents = Array.isArray(list) ? list : [];
        },

        // Agrupa o rascunho por origem, espelhando as chamadas que o card faria
        // sequencialmente em uma turma já existente.
        buildOfferIntentsPayload(){

            const workTimeId = this.acesso.periodo.id;
            const byOrigin = { module: [], manual: [] };

            this.draftOfferIntents.forEach(d => {
                const origin = d.origin === 'module' ? 'module' : 'manual';
                if(d.discipline_id && byOrigin[origin].indexOf(d.discipline_id) < 0){
                    byOrigin[origin].push(d.discipline_id);
                }
            });

            return ['module', 'manual']
                .filter(o => byOrigin[o].length > 0)
                .map(o => ({ work_time_id: workTimeId, discipline_ids: byOrigin[o], origin: o }));
        },

        onPlanningSequencyChange(val){
            // O card "Planejamento de Oferta" alterou o módulo escolhido.
            // Mantém o estado da turma em sincronia.
            this.model.curriculum_sequency_item_id = val || null;
            this.curriculumSequencyItemId = val || null;
        },

        bulkGenerateFromIntents(group){
            // Prepara a geração de grids diretamente a partir das intents do work_time.
            if(!group || !group.intents || !group.intents.length){
                return;
            }
            const blocking = group.intents.filter(i => !i.prerequisite_ok);
            if(blocking.length){
                const proceed = window.confirm(
                    blocking.length + ' disciplina(s) deste período letivo têm pré-requisito pendente. Deseja prosseguir mesmo assim?'
                );
                if(!proceed) return;
            }
            // Monta o snapshot e abre o modal de confirmação. A confirmação dispara
            // generateOfferFromIntents() que chama o backend.
            this.pendingGenerationGroup = group;
            this.showGenerateOffer = true;
        },

        generateOfferFromIntents(){
            const group = this.pendingGenerationGroup;
            if(!group){ this.showGenerateOffer = false; return; }

            const disciplines = group.intents
                .map(i => i.discipline && { id: i.discipline.id })
                .filter(d => d && d.id);

            this.error = null;
            this.message = '';
            this.loadingOffer = true;

            // Usa offer_type_id=1 (Avulsa): mais flexível, não exige curriculum_id
            // e aceita lista plana de disciplinas — encaixa perfeito no modelo de intents.
            const payload = {
                id:                             this.model.id,
                curriculum_id:                  this.model.curriculum_id || null,
                curriculum_sequency_item_id:    this.model.curriculum_sequency_item_id || null,
                offer_type_id:                  1,
                disciplines:                    disciplines,
                // Garante geração incremental — não apaga grids existentes.
                preserve_existing:              true,
            };

            this.ActionGenerateGrids(payload)
                .then((res) => {
                    if(res.success){
                        this.message = 'Grids gerados com sucesso para ' + (group.work_time.name || (group.work_time.year + '/' + group.work_time.period)) + '.';
                    }
                    // Atualiza o planejamento (intents consumidos somem)
                    if(this.$refs.offerIntentsPlanning){
                        this.$refs.offerIntentsPlanning.load();
                    }
                })
                .catch((error) => {
                    this.error   = error;
                    this.errors  = error && error.errors ? error.errors : {};
                    this.message = error && error.message ? error.message : 'Falha ao gerar grids.';
                })
                .finally(() => {
                    this.loadingOffer       = false;
                    this.showGenerateOffer  = false;
                    this.pendingGenerationGroup = null;
                });
        },

        clearOffer(){
            this.disciplines = [];
            this.model.curriculum_sequency_item_id = null;
            this.selectedCurriculum = {};
            this.model.disciplines = [];
            this.model.curriculum_id = null;
            this.model.baseGroups = [];
            this.model.offer_type_id = 1;
            this.offerTypeMode = 1;
        },

        generateOffer(){
                
            this.error = null;
            this.message = '';
            this.loadingOffer = true;
           
            var payload = {
                id:                             this.model.id,
                curriculum_id:                  this.model.curriculum_id,
                curriculum_sequency_item_id:    this.model.curriculum_sequency_item_id,
                offer_type_id:                  this.model.offer_type_id,
                disciplines:                    this.model.disciplines
            };
            
            this.ActionGenerateGrids(payload)
                .then((res) => {
                   if(res.success){
                        this.message = 'Oferta gerada com sucesso!';
                   }
                })
                .catch((error) =>{
                    this.error      = error;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                    this.loadingOffer = false;
                    this.showGenerateOffer = false;
                });
        },
        
        save(edit)
        {
            this.error = null;
            this.message = '';
            this.loading = true;
            let payload = { groups: [] };

            Object.assign(payload, this.model);
            Object.assign(payload, { work_time_id: this.acesso.periodo.id });
            Object.assign(payload.groups, this.model.baseGroups.map(o => ({ base_group_id: o['id'] })));

            // Turma nova: o planejamento montado em rascunho vai no mesmo POST e
            // é gravado atomicamente com a turma. No edit o card é server-driven
            // e já persistiu tudo.
            if(!edit){
                const offerIntents = this.buildOfferIntentsPayload();

                if(offerIntents.length){
                    payload.offer_intents = offerIntents;
                }
            }


            if (edit) {
                this.ActionUpdateGroup(payload)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted');
                })
                .catch((error) =>{
                    this.error      = error;
                    this.errors     = error.errors;
                    this.message    = error.message;

                    let count = 0;
                    Object.keys(error.errors).forEach(e => {
                        if(e.includes('groups.')){
                            count++;
                        }
                    });

                    if(count > 0){
                        this.errors.groups = ['Turma base ja utilizada em outra turma'];
                    }
                })
                .finally(() => {
                     this.loading = false;
                })
            } else {
                this.ActionCreateGroup(payload)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted', res.data);
                })
                .catch((error) =>{
                    this.error      = error;
                    this.errors     = error.errors;
                    this.message    = error.message;

                    // Turma rejeitada por causa do planejamento: leva o usuário
                    // até onde estão os erros. Nada foi criado no banco.
                    if(this.offerIntentErrors.length){
                        this.tab = 'offer';
                    }

                    let count = 0;
                    Object.keys(error.errors).forEach(e => {
                        if(e.includes('groups.')){
                            count++;
                        }
                    });

                    if(count > 0){
                        this.errors.groups = ['Turma base ja utilizada em outra turma'];
                    }
                })
                .finally(() => {
                   this.loading = false;
                })

            }
        },

        showDeleteItem(item){

            this.selectedItem = item;
            this.showDeleteDiscipline = true;

        },

        deleteItem(){
            
            var index = this.model.disciplines.indexOf(this.selectedItem);
            this.model.disciplines.splice(index, 1);
            this.showDeleteDiscipline = false;
            
        },

        selectDiscipline(items){
            
            if(items && items.length > 0){
                items.forEach(i => {
                    var find = this.model.disciplines.find(d => d.id == i.id);
                    if(!find){
                        this.model.disciplines.push(i);
                    }
                });
            }
           
        },
        
    }
}
</script>